export const appleIdTokenParser = (hash: string) => {
  if (!hash) {
    return null;
  }
  const queryString = hash.substring(1);
  const params = new URLSearchParams(queryString);
  return params.get("id_token");
};
